import React from 'react';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { tabsOpened } from '../../store/actions/tabs';
import { IRefIds } from '../../constants/refs';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

interface IAudioItemsButtonProps {
  courseId: number;
  refId: IRefIds;
  ids: number[];
  disabled?: boolean;
}

const AudioItemsButton: React.FC<IAudioItemsButtonProps> = ({ courseId, refId, ids, disabled = false }) => {
  const dispatch = useDispatch();

  const handleOpenItems = () => {
    if (ids.length > 0) {
      dispatch(
        tabsOpened({
          refId,
          search: ids.join(','),
          courseId,
        }),
      );
    }
  };

  if (ids.length === 0) {
    return <EmptyText>No items</EmptyText>;
  }

  return (
    <StyledButton
      variant="contained"
      size="small"
      onClick={handleOpenItems}
      disabled={disabled}
      title={`View ${ids.length} items`}
    >
      <ButtonContent>
        <span>{ids.length}</span>
        <StyledIcon icon={faExternalLinkAlt} />
      </ButtonContent>
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  && {
    font-size: 13px;
    font-weight: 600;
    padding: 4px 10px;
    min-width: auto;
    text-transform: none;
    background-color: #5f84ef;
    color: white;
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(95, 132, 239, 0.3);
    transition: all 0.3s ease;

    &:hover {
      background-color: #4a6ddb;
      box-shadow: 0 4px 8px rgba(95, 132, 239, 0.4);
      transform: translateY(-1px);
    }

    &:disabled {
      background-color: #e0e0e0;
      color: #999;
      box-shadow: none;
    }
  }
`;

const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const StyledIcon = styled(FontAwesomeIcon)`
  font-size: 11px;
  opacity: 0.8;
`;

const EmptyText = styled.span`
  font-size: 12px;
  color: #999;
  font-style: italic;
`;

export default AudioItemsButton;
